import { QuoteService as QuoteServiceSynthesisCore} from 'quote-export-manager-core';
import { ExtraFeeV1Mapper } from './extra-fee-v1.mapper';
import { CustomGroupV1Mapper } from './custom-group-v1.mapper';
import {Injectable} from '@angular/core';
import {QuoteService} from '../../../core/models/quote/quote-service';
@Injectable()
export class QuoteServiceV1Mapper {
  constructor(
    private readonly extraFeeV1Mapper: ExtraFeeV1Mapper,
    private readonly customGroupV1Mapper: CustomGroupV1Mapper,
  ) {}


  toQuoteService(quoteService: QuoteService): QuoteServiceSynthesisCore {
    if(!quoteService) {
        return null;
    }
    return new QuoteServiceSynthesisCore(
      quoteService.code,
      quoteService.contractInfoInputs,
      quoteService.appliedPrice,
      quoteService.appliedPriceColor,
      quoteService.appliedPriceDevices,
      quoteService.appliedPriceConsumables,
      quoteService.appliedPriceDevicesColor,
      quoteService.appliedPriceConsumablesColor,
      quoteService.distance,
      quoteService.pct,
      quoteService.averagePctCoefficient,
      quoteService.nonNegociableArticleColor,
      quoteService.uniqueReferenceCoefficient,
      quoteService.totalLogisticsPrice,
      quoteService.factorVt,
      quoteService.factorFreeMonth,
      quoteService.extraFees?.filter((fee) => fee.checked).map((fee) =>
        this.extraFeeV1Mapper.toExtraFee(fee),
      ),
      quoteService.discount,
      quoteService.isCustomGroups,
      quoteService.customGroups?.map((group) =>
        this.customGroupV1Mapper.toCustomGroup(group),
      ),
      quoteService.indexCustomGroup,
      quoteService.quoteType,
      quoteService.additionalStockAmount,
      quoteService.monthlyAmount,
      quoteService.weeklyAmount,
      quoteService.salesType
    );
  }
}
